import api from '@/api';
import { isEmpty } from 'lodash';
import { merParams, settingsInfoParams } from './libs/formats/infoParams';
import { settingParamsForFieldsRequest } from './libs/formats/requestFieldsParams';
import { mer } from '@/restore/reports/mer';

const createLog = () => {
    return {
        info: msg => {
            // eslint-disable-next-line no-console
            console.log(`%c${msg}`, 'color: blue;');
        },
        error: msg => {
            // eslint-disable-next-line no-console
            console.log(`%c${msg}`, 'color: red;');
        },
    };
};

const log = createLog();

/*
    Это модель отчетов, ответственность которой следить за выбором в информационном дереве.
    Отвечает за простановку следующих параметров при формировании отчёта:
    - workshopIDs
    - fieldIDs
    - areaIDs
    - mineIDs
*/

/*
    Логика работы.
    Выбранный элемент из информационного дерева участвует в формировании отчета.
    Если этот выбранный элемента не перечислен в списке nodesWithoutRequest, формируется запрос
    за необходимыми данными, которые уже фигурируют в отчете.

    По "необходимыми данными" понимается список месторождений (из ids).
*/

const initialState = {
    fieldIds: [],
    prevCalculationObjectForRequest: null,
};

/*
    Тип элементов из информационного дерева, не требующих до запроса за набором id месторождений
*/
const nodesWithoutRequest = ['field', 'area', 'pad'];

export const infoReportsModel = {
    name: 'infoReports',
    state: initialState,
    reducers: {
        setResponseData(state, payload) {
            return { ...state, fieldIds: payload };
        },
        setPrevCalculationObject(state, payload) {
            return { ...state, prevCalculationObjectForRequest: payload };
        },
    },
    effects: {
        async getFields(calculationObject, rooState) {
            const fieldIdsFromState = rooState.infoReports.fieldIds;
            const prevObject = rooState.infoReports.prevCalculationObjectForRequest;

            if (isEqualCalculationObject(prevObject, calculationObject)) {
                log.info('field ids from state WITHOUT REQUEST');
                return fieldIdsFromState;
            }

            try {
                const params = settingParamsForFieldsRequest(calculationObject);
                const fieldIds = await api.reports.getFieldIds(params);

                this.setResponseData(fieldIds);
                this.setPrevCalculationObject(calculationObject);

                return fieldIds;
            } catch (error) {
                log.error(error);
                throw new Error('function call getFieldIds failed with an error');
            }
        },
        async getInfoParams(_, rootState) {
            const withTree = rootState.baseFilterReport.withTree;
            const reportType = rootState.filterReport.reportType;
            const isMer = reportType[0] === 'Mer';

            const calculationObject = rootState.tree.calculationObject;

            if (isMer) {
                const params = mer.getMerParams();
                return merParams(params);
            }

            /*
                Если происходит работа с деревом, то формируется настройки ПО УМОЛЧАНИЮ
            */
            if (withTree || calculationObject === null) {
                return settingsInfoParams();
            }

            /*
                Если условие валидное, то настройки формируются согласно выбранному элементу из информационного дерева
            */
            if (nodesWithoutRequest.includes(calculationObject.node)) {
                return settingsInfoParams({ [calculationObject.node]: calculationObject.id });
            }

            /*
                Иначе запрос (см. описание в начале файла)
            */
            const fieldIds = await this.getFields(calculationObject);
            const fieldIdsParam = isEmpty(fieldIds) ? 0 : fieldIds.join(',');

            return settingsInfoParams({ field: fieldIdsParam });
        },
    },
};

/*
    Сравнение двух calculationObject (предыдущих и текущих).
*/
function isEqualCalculationObject(prev, current) {
    if (!prev) return false;

    return prev.id === current.id && prev.node === current.node;
}
